function downloadImage(button) {
  // Find the closest parent div with the class 'imagebox'
  const imageBox = button.closest('.imagebox');
  
  // Find the img element within this imagebox
  const img = imageBox.querySelector('img');
  
  // Get the src attribute of the img element
  const imgSrc = img.getAttribute('data-src');

  const baseUrl = imgSrc.split('?')[0];
  
  // Create a download link and trigger the download
  const link = document.createElement('a');
  link.href = baseUrl;
  link.download = 'download.jpg';
  document.body.appendChild(link);
  // console.log('link', link)
  link.click();
  document.body.removeChild(link);
}
